var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFolderInactive = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A5B3C2",
    fillRule: "evenodd",
    d: "M16.25 17.083H3.75c-1.148 0-2.083-.909-2.083-2.026V4.943c0-1.117.935-2.026 2.083-2.026h3.834c.25 0 .487.112.645.306l2.166 2.649h5.855c1.148 0 2.083.909 2.083 2.026v7.159c0 1.117-.935 2.026-2.083 2.026",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFolderInactive, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/folder_inactive.5e113130.svg";
export { ForwardRef as ReactComponent };